/*
 * 积分商城 相关接口
 * */
import request from "@utils/request";

/**
 * 通过积分商品id查询订单信息
 * @param cartId
 * @returns {*}
 */
export function postOrderConfirm(id) {
  return request.get("/integral_product/detail/" + id, {}, { login: false });
}


/**
 * 积分商城下单
 * @param key
 * @param data
 * @returns {*}
 */
export function createOrder(data) {
  return request.post("/order/create_integral", data );
  // return request.post("/order/create_integral_new", data );
}

/**
 * 查询积分订单列表
 * @param key
 * @param data
 * @returns {*}
 */
export function integral_order_list(data) {
  return request.get("/order/list_integral",data );
}


/**
 * 查询积分订单详情
 * @param key
 * @param data
 * @returns {*}
 */
export function detail_integral(id) {
  return request.get("/order/detail_integral/"+id );
}
